import styled from '@emotion/styled';
import { theme, media } from '@vfit/shared/themes';
import { IPassionCardTopImage } from './passionCard.models';

export const PassionCardContainer = styled.div<{ isApp?: boolean; iconSize?: number }>`
  display: flex;
  flex: 1;
  border: 1px solid #ccc;
  border-radius: ${({ isApp }) => `${isApp ? '6px' : '20px'}`};
  flex-direction: column;
  margin-left: 20px;

  ${media.tablet`
    margin-left: 0;
  `}

  ${media.desktop`
    margin-left: 0;
  `}
`;

export const PassionCardTopImage = styled.div<IPassionCardTopImage>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  height: 150px;
  border-radius: ${({ isApp }) => `${isApp ? '6px 6px 0 0' : '20px 20px 0 0'}`};
  position: relative;

  img {
    position: absolute;
    top: 0;
    left: 0;
  }

  ${({ large }) => media.tablet`
    height: ${large ? '400px' : '200px'};
  `}

  ${({ large }) => media.desktop`
    height: ${large ? '400px' : '200px'};
  `}
`;

export const PassionCardTopImageJiustifyContentBox = styled.div`
  width: calc(100% - 48px);
  margin: 0 auto;
  height: calc(100% - 38px);
  margin-top: 22px;
  position: relative;

  & > div,
  & > h2 {
    position: absolute;
    left: 0;
  }

  & > div {
    top: 0;
  }

  & > h2 {
    bottom: 0;
  }
`;

// pxToCssFont(28, 36) → ratio = 36/28 = 1.286 → nearest lineHeight token: h4/h5: 1.3 (delta: 0.014) ✓
// fontSize 28px → h4: 1.75rem ✓
export const TitleAboveImg = styled.h2`
  font-size: ${theme.typography.fontSize.h4};
  line-height: ${theme.typography.lineHeight.h4};
  margin: 0;
  color: white;
  z-index: 1;
`;

export const PassionCardBottom = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  background: ${theme.colors.bg.primary};
  backdrop-filter: blur(40px);
  min-height: 280px;
`;

export const PassionCardBottomContainer = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 32px;

  ${media.tablet`
    margin-left: 20px;
    margin-right: 20px;
  `}

  ${media.desktop`
    margin-left: 20px;
    margin-right: 20px;
  `}
`;

export const PassionCardBottomContainerText = styled.div`
  margin-top: 32px;

  h3 {
    margin: 0;
    font-family: ${theme.typography.fontFamily.primary};
    color: ${theme.colors.text.primary};
    font-weight: ${theme.typography.fontWeight.extrabold};
    /* pxToCssFont(30, 38) → ratio = 38/30 = 1.267 → nearest: h4/h5: 1.3 (delta: 0.033) ✓ */
    /* fontSize 30px → nearest: h3: 2rem/32px (delta:2) vs h4: 1.75rem/28px (delta:2) → h3 wins (closer or tie → pick larger) */
    font-size: ${theme.typography.fontSize.h3};
    line-height: ${theme.typography.lineHeight.h4};
  }

  p {
    margin: 0;
    margin-top: ${theme.spacing.lg};
    font-family: ${theme.typography.fontFamily.primary};
    color: ${theme.colors.text.primary};
    font-weight: ${theme.typography.fontWeight.regular};
    /* pxToCssFontSize(18) → body1: 1.125rem ✓ */
    font-size: ${theme.typography.fontSize.body1};
  }

  ${media.tablet`
    p {
      font-size: ${theme.typography.fontSize.body1};
    }
  `}

  ${media.desktop`
    h3 {
      /* pxToCssFont(36, 45) → ratio = 45/36 = 1.25 → nearest: h3: 1.25 (delta: 0) ✓ */
      /* fontSize 36px → h2: 2.25rem ✓ */
      font-size: ${theme.typography.fontSize.h2};
      line-height: ${theme.typography.lineHeight.h3};
    }

    p {
      font-size: ${theme.typography.fontSize.body1};
    }
  `}
`;

export const TextContainer = styled.div<{ lineHeight?: number }>`
  div {
    margin: 0;
    margin-top: ${theme.spacing.lg};
    /* pxToCssFont(18, lineHeight||22) → fontSize 18px → body1 ✓ */
    /* ratio = 22/18 = 1.222 → nearest: h2: 1.2 (delta: 0.022) vs h3: 1.25 (delta: 0.028) → h2 wins */
    /* lineHeight prop preserved as raw value when provided; fallback maps 22px ratio */
    font-size: ${theme.typography.fontSize.body1};
    line-height: ${({ lineHeight }) =>
      lineHeight ? lineHeight / 18 : theme.typography.lineHeight.h2};
    color: ${theme.colors.text.primary};
  }

  ${media.desktop`
    div {
      margin: 0;
      margin-top: ${theme.spacing.lg};
    }
  `}
`;

export const PassionAction = styled.div`
  margin-left: ${theme.spacing.lg};
  margin-right: ${theme.spacing.lg};
  margin-bottom: 32px;

  ${media.tablet`
    margin-left: 20px;
    margin-right: 20px;
  `}

  ${media.desktop`
    margin-left: 20px;
    margin-right: 20px;
  `}
`;

export const DescriptionText = styled.div`
  font-family: ${theme.typography.fontFamily.primary};
  text-align: left;
`;
